import React from 'react';
import './AppDecorBackground.css';

const ink = 'currentColor';

const ViolinSvg = () => (
    <svg viewBox="0 0 200 320" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
        <path
            d="M118 8C112 28 98 42 88 58C78 76 72 98 70 118C68 138 72 158 82 172C88 180 96 186 100 198C104 212 98 228 88 242C76 258 62 278 58 298C56 308 62 316 72 316C88 316 102 298 110 278C118 256 124 232 128 208C132 184 136 160 142 138C148 114 158 92 168 72C176 56 182 40 178 24C174 10 162 4 148 6C132 8 118 8 118 8Z"
            stroke={ink}
            strokeWidth="2.2"
            strokeLinejoin="round"
        />
        <ellipse cx="100" cy="52" rx="22" ry="14" stroke={ink} strokeWidth="2" />
        <path d="M100 66V118" stroke={ink} strokeWidth="2" />
        <path d="M78 88H122" stroke={ink} strokeWidth="1.8" />
        <path d="M82 102H118" stroke={ink} strokeWidth="1.5" />
        <path d="M86 116H114" stroke={ink} strokeWidth="1.5" />
        <path
            d="M94 198C88 210 84 224 86 238C88 252 96 262 108 264"
            stroke={ink}
            strokeWidth="2"
            strokeLinecap="round"
        />
        <path d="M58 278L72 302" stroke={ink} strokeWidth="2.5" strokeLinecap="round" />
        <circle cx="58" cy="306" r="10" stroke={ink} strokeWidth="2" />
    </svg>
);

const FeatherSvg = () => (
    <svg viewBox="0 0 120 200" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
        <path
            d="M60 190C58 160 52 130 48 100C44 72 42 48 44 28C46 12 54 4 60 2C66 4 74 12 76 28C78 48 76 72 72 100C68 130 62 160 60 190Z"
            stroke={ink}
            strokeWidth="2"
            strokeLinejoin="round"
        />
        <path d="M60 190V8" stroke={ink} strokeWidth="2.5" strokeLinecap="round" />
        <path d="M60 160L28 140M60 130L24 118M60 100L26 88M60 72L30 62M60 44L36 38" stroke={ink} strokeWidth="1.2" strokeLinecap="round" />
        <path d="M60 160L92 140M60 130L96 118M60 100L94 88M60 72L90 62" stroke={ink} strokeWidth="1.2" strokeLinecap="round" />
    </svg>
);

const QuillSvg = () => (
    <svg viewBox="0 0 100 120" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
        <path d="M72 8L28 108" stroke={ink} strokeWidth="2.5" strokeLinecap="round" />
        <path d="M28 108L18 112L22 102L28 108Z" fill={ink} fillOpacity="0.35" stroke={ink} strokeWidth="1.5" strokeLinejoin="round" />
        <path d="M68 14C62 22 54 32 46 44" stroke={ink} strokeWidth="1.2" strokeLinecap="round" />
        <ellipse cx="38" cy="98" rx="18" ry="10" stroke={ink} strokeWidth="1.8" />
        <path d="M24 98H52" stroke={ink} strokeWidth="1.2" />
    </svg>
);

const MusicNotesSvg = () => (
    <svg viewBox="0 0 80 100" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
        <ellipse cx="18" cy="78" rx="10" ry="8" fill={ink} fillOpacity="0.5" />
        <path d="M28 78V28" stroke={ink} strokeWidth="2.5" strokeLinecap="round" />
        <path d="M28 28C40 24 52 20 58 32C64 44 50 48 38 52" stroke={ink} strokeWidth="2" fill="none" />
        <ellipse cx="48" cy="58" rx="9" ry="7" fill={ink} fillOpacity="0.45" />
        <path d="M57 58V18" stroke={ink} strokeWidth="2.5" strokeLinecap="round" />
        <ellipse cx="62" cy="88" rx="8" ry="6" fill={ink} fillOpacity="0.4" />
        <path d="M70 88V48" stroke={ink} strokeWidth="2" strokeLinecap="round" />
    </svg>
);

const StaffSvg = () => (
    <svg viewBox="0 0 180 60" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
        {[12, 22, 32, 42, 52].map((y) => (
            <path key={y} d={`M8 ${y}H172`} stroke={ink} strokeWidth="1.2" strokeLinecap="round" />
        ))}
        <ellipse cx="36" cy="32" rx="7" ry="5.5" fill={ink} fillOpacity="0.35" />
        <path d="M43 32V12" stroke={ink} strokeWidth="2" />
    </svg>
);

const AppDecorBackground = () => (
    <div className="app-decor" aria-hidden>
        <div className="app-decor__wash" />
        <div className="app-decor__item app-decor__feather">
            <FeatherSvg />
        </div>
        <div className="app-decor__item app-decor__violin">
            <ViolinSvg />
        </div>
        <div className="app-decor__item app-decor__quill">
            <QuillSvg />
        </div>
        <div className="app-decor__item app-decor__notes-tr">
            <MusicNotesSvg />
        </div>
        <div className="app-decor__item app-decor__notes-bl">
            <MusicNotesSvg />
        </div>
        <div className="app-decor__item app-decor__staff">
            <StaffSvg />
        </div>
    </div>
);

export default AppDecorBackground;
